// extracted by mini-css-extract-plugin
export default {"FullPage":"Main_FullPage__719Up","Card":"Main_Card__27sds"};